"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const isString_1 = require("../predicates/isString");
exports.test = (expression) => {
    const clonedExpression = new RegExp(expression.source, expression.flags);
    return (value) => isString_1.isString(value) && !(clonedExpression.lastIndex = 0) && clonedExpression.test(value);
};
//# sourceMappingURL=test.js.map